import React from "react";
import PropTypes from "prop-types";
import ReactTable from "react-table";

import Loading from "../../common/Loading";
import { PREPAID_DEFERRED_REVENUE_BALANCE_COLUMNS } from "./columns";

const PrepaidDeferredRevenueBalanceList = ({
  data,
  loading,
  pages,
  page,
  sorted,
  pageSize,
  onRowClick = () => {},
  onPageChange,
  onSortedChange,
  onPageSizeChange
}) => {
  if (loading)
    return (
      <div className="loading">
        <Loading />
      </div>
    );

  return data && data.length ? (
    <div className="content-wrapper">
      <ReactTable
        className="-highlight"
        data={data}
        columns={PREPAID_DEFERRED_REVENUE_BALANCE_COLUMNS}
        pages={pages}
        manual
        sorted={sorted}
        pageSize={Math.min(pageSize)}
        page={page}
        onPageChange={onPageChange}
        showPagination
        onSortedChange={onSortedChange}
        onPageSizeChange={onPageSizeChange}
        defaultSorted={[{ id: "name", desc: false }]}
        getTrProps={(state, rowInfo) => ({
          onClick: () => onRowClick(rowInfo),
          style:
            rowInfo?.index === state?.data?.length - 1
              ? {
                  fontWeight: "700"
                }
              : {}
        })}
      />
    </div>
  ) : (
    <div className="loading">
      <h4 style={{ opacity: 0.15 }}>No Data</h4>
    </div>
  );
};

PrepaidDeferredRevenueBalanceList.propTypes = {
  data: PropTypes.array,
  page: PropTypes.number,
  pages: PropTypes.number,
  loading: PropTypes.bool,
  onRowClick: PropTypes.func,
  onPageChange: PropTypes.func,
  onSortedChange: PropTypes.func,
  onPageSizeChange: PropTypes.func,
  pageSize: PropTypes.number,
  sorted: PropTypes.array
};

export default PrepaidDeferredRevenueBalanceList;
